import { useState } from 'react';

import { StructuredModal } from '@moniebook-web/components/atoms/structured-modal';
import { DropdownMenu } from '@moniebook-web/components/molecules/dropdown-menu';
import { useScreenInfo } from '@moniebook-web/components/shared/hooks';
import { ArrowDropDownLine } from '@moniebook-web/icons/arrows/arrow-drop-down-line';
import { mergeClassNames, useUserInfo } from '@moniebook-web/utils';

import { BusinessSwitcher } from './business-switcher';
import { DropdownContent } from './dropdown-content';

export function UserDropdown() {
    const [openSwitchBusiness, setOpenSwitchBusiness] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { currentBusiness } = useUserInfo(true);
    const { isMobile } = useScreenInfo();

    const handleToggleSwitchBusiness = () => {
        setOpenSwitchBusiness((prev) => !prev);
    };

    return (
        <>
            <BusinessSwitcher
                open={openSwitchBusiness}
                onClose={handleToggleSwitchBusiness}
            />
            {isMobile ? (
                <>
                    <button
                        type='button'
                        onClick={() => setDropdownOpen(true)}
                        className='min-w-0 outline-none focus-within:outline-none focus:outline-none'>
                        <DropdownTriggerContent
                            businessName={currentBusiness?.name}
                        />
                    </button>
                    <StructuredModal.Modal
                        type='bottomsheet'
                        isOpen={dropdownOpen && isMobile}
                        onClose={() => setDropdownOpen(false)}
                        className='m-16 mobile:mb-16 mobile:rounded-[6px] rounded-[6px] p-0'>
                        <StructuredModal.Body className='p-0'>
                            <DropdownContent
                                onClose={() => setDropdownOpen(false)}
                                onSwitchBusiness={handleToggleSwitchBusiness}
                            />
                        </StructuredModal.Body>
                    </StructuredModal.Modal>
                </>
            ) : (
                <DropdownMenu
                    className='w-[298px] min-w-0 rounded-[6px]! p-0! shadow-elevation-overlay'
                    trigger={
                        <button
                            type='button'
                            onMouseEnter={(event) => event.stopPropagation()}
                            className='min-w-0 outline-none focus-within:outline-none focus:outline-none'>
                            <DropdownTriggerContent
                                businessName={currentBusiness?.name}
                            />
                        </button>
                    }
                    contentProps={{
                        onCloseAutoFocus: (event: MouseEvent) =>
                            event.preventDefault(),
                        onMouseEnter: (event: MouseEvent) =>
                            event.stopPropagation(),
                    }}>
                    <DropdownContent
                        onClose={() => setDropdownOpen(false)}
                        onSwitchBusiness={handleToggleSwitchBusiness}
                    />
                </DropdownMenu>
            )}
        </>
    );
}

function DropdownTriggerContent({
    businessName,
}: Readonly<{ businessName?: string }>) {
    return (
        <div
            className={mergeClassNames(
                'flex h-24 w-full min-w-0 items-center justify-start gap-4 rounded-[6px] px-4 hover:bg-new-alpha-100',
                'min-w-0 focus:bg-new-alpha-100',
            )}>
            <span className='w-full min-w-0 truncate font-medium text-14 text-content-body-default'>
                {businessName}
            </span>
            <ArrowDropDownLine className='shrink-0 text-new-neutral-700' />
        </div>
    );
}
